import React from 'react';
import 'styles/css/accordion.scss'
import Switcher from 'blocks/Switcher';
import BigInput from 'blocks/BigInput';
import {TARGET_AUDIENCES_MULTISELECT} from './constants';
import MultiSelectWrapper from 'blocks/MultiSelectWrapper';
import classNames from 'classnames';
import {observer, inject} from 'mobx-react';
import {TARGET_FILE_CONTENT_TYPES, TARGET_FILE_MAX_SIZE} from './constants';
import AccordionModule from './create_module/AccordionModule';
import Collapsible from 'react-collapsible';
import AccordionHeader from 'blocks/accordion/AccordionHead';
import {observe} from 'mobx';
import _ from 'lodash';
import {Link} from 'react-router-dom';
import AddDiscountCode from './AddDiscountCode';
import QuillEditor from './QuillEditor';
import Textarea from "react-textarea-autosize";
import infoIcon from '../../styles/img/info.svg';
import { SingleDatePicker } from 'react-dates';
import 'rc-time-picker/assets/index.css';
import TimePicker from 'rc-time-picker';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';

@inject('publicWebinarCreate')
@inject('alert')
@inject('deleteModal')
@inject('user')
@observer
export default class WorkShopBasicInformation extends React.Component {

  state = {
    opened: true,
    editorHtml: '',
    showPopup: false,
  };

  handleChange = data => {
    this.props.handleChange(data);
  };

  handleChangeRte = (value) => {
    this.props.publicWebinarCreate.setDescription(value)
  }

  handleChangeSummary = e => {
    this.handleChange({summary: e.target.value});
  }

  handleChangeWebinarLink = e => {
    this.handleChange({zoom_link: e.target.value});
  }

  componentDidMount = () => {
    this.moduleKey = 10000;
    this.stateObserve = observe(this.props.publicWebinarCreate, 'openedEntity', () => {
      let openedEntity = this.props.publicWebinarCreate.openedEntity;
      if(openedEntity.type === 'group_supervision')
        this.setState({opened: true});
      else {
          this.setState({opened: false});
      }
    });
  };
  componentWillUnmount = () => {
    this.stateObserve();
  };
  updateMoreInfo = e => {
    let file = e.target.files[0];
    if(file.size > TARGET_FILE_MAX_SIZE || !TARGET_FILE_CONTENT_TYPES.includes(file.type)){
      this.props.alert.info('File invalid')
    }
    else {
      if (e.target.files && e.target.files[0]) {
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onload = e => {
          let newWorkshop = _.assign({}, {
            more_info: file,
            file_name: file.name,
            file_size: file.size
          });
          this.props.publicWebinarCreate.handleChange(newWorkshop)
        };
        reader.readAsDataURL(e.target.files[0]);
      }
    }
  };

  setOpen = ({ open }) => {
    this.setState({ open });
  };

  setOpenEnd = data => {
    this.setState({endOpen: !this.state.endOpen});
  };

  deleteFile = () => {
    if(this.props.publicWebinarCreate.workshop.more_info === 1){
      this.props.deleteModal.eventDelete({type: 'file', fileTo: 'workshop'})
    }
    else
      this.props.deleteFile();
  };

  switchModules = () => {
    this.props.publicWebinarCreate.changeHasModules();
  };

  addEmptyModule = () => {
    let key = this.moduleKey++;
    this.props.publicWebinarCreate.addEmptyModule(key);
    this.props.publicWebinarCreate.handleChangeOpenedEntity({type: 'module', id: key });
  };

  handler = () => {
    if(this.props.publicWebinarCreate.openedEntity.type === 'group_supervision') {
      this.props.publicWebinarCreate.handleChangeOpenedEntity({type: 'none', id: 0});
    }
    else
      this.props.publicWebinarCreate.handleChangeOpenedEntity({type: 'group_supervision'})
  };

  handlePopup = () => this.setState({showPopup: !this.state.showPopup});

  render() {
    const {showPopup} = this.state;
    const EMPTY_FILE = (
      <label>
      <li className="file-item">
        <div className="file-item-inner">
          <i className="ic-upload-ico file-icon"/>
          <div className='file-link'>
            <p className="file-link-size">Formats allowed:</p>
            <p className="file-link-size">PDF, Word (Max size 5MB)</p>
          </div>
        </div>
        <input type="file" style={{display: 'none'}} onChange={this.updateMoreInfo}/>
      </li>
    </label>);

    const FILE_PREVIEW = (<li className="file-item">
      <div className="file-item-inner">
        <i className="file-icon ic-file-ico"/>
        <div className="file-link">
          <p className="file-link-active">{this.props.publicWebinarCreate.getWorkShop().file_name}</p>
          <p className="file-link-size">{parseInt(this.props.publicWebinarCreate.getWorkShop().file_size / 1000)} KB</p>
        </div>
      </div>
      <span onClick={this.deleteFile} className="file-delete">
        <i className="ic-close-ico"/>
        </span>
    </li>);


    let newCaption = '';
    let description = this.props.publicWebinarCreate.getWorkShop().description;
    if(description !== '' ) {
      newCaption = document.createElement('div');
      newCaption.innerHTML = description.replace(/<\/p>/gm, ' ').replace(/<(?:.|\n)*?>/gm, '');
      newCaption = newCaption.textContent;
    }
    const data ={head: {
      label: !!this.props.publicWebinarCreate.workshop.title ? this.props.publicWebinarCreate.workshop.title : 'Workshop Title',
      icon: 'ic-flag-ico',
      caption: !!newCaption ? newCaption.substr(0,100) : 'Workshop description',
      withBtn: false,
      open: this.state.opened
    }};

    const trigger =  <div className={classNames({'module-has-error': !_.isEmpty(this.props.publicWebinarCreate.getErrors()) })}> <AccordionHeader
      label={data.head.label}
      icon={data.head.icon}
      number={0}
      caption={data.head.caption}
      withBtn={data.head.withBtn || false}
      btn={{}}
    /></div>;

    return (
      <div className="col-12 col-md-9 pull-md-3 customregular-dates">
        <div className="regular-workshop-content">
          <div className="workshop-module gutter" key="workshop">
            <Collapsible
              className="accordion-item"
              openedClassName="accordion-item is-active"
              open={data.head.open}
              trigger={trigger}
              handleTriggerClick={this.handler}>
              <div className="accordion workshop-creator">
                  <div className="accordion-content">
                    <button
                      className='info-button'
                      onClick={this.handlePopup}
                    >
                      <img src={infoIcon} />
                    </button>
                    <div className={classNames({'popup': true, 'showPopup': showPopup})}>
                      <ul>
                        <li>Fill out the details of your online workshop / course / webinar below</li>
                        <li>Click ‘Submit Workshop Info’ to send us the details of the proposed course</li>
                        <li>Once approved, you can add and save all your course content in editing mode (keep a copy yourself)</li>
                        <li>Our team will assist you every step of the way</li>
                        <li>When you wish, we will publish the course live on Therapy Academy</li>
                      </ul>
                    </div>
                    <div className="row">
                      <div className="col-12">
                        <div className="accordion-content-block">
                          <p className="label">Online Workshop Or Regular (Offline) Workshop Or Live Webinar?</p>
                          <Link to={{pathname: '/createwebinar'}}>
                            <span className="btn bordered empty grey-empty">LIVE Webinar</span>
                          </Link>
                          <Link to="/createworkshop">
                            <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>ONLINE WORKSHOP</span>
                          </Link>
                          <Link to='/createregular'>
                            <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>REGULAR</span>
                          </Link>
                          {/* {this.props.user.getUser().role === 'admin' && */}
                            <span className="btn bordered prime" style={{marginLeft: 10}}>PUBLIC WEBINARS</span>
                          {/* } */}
                          {/* {this.props.user.getUser().role === 'admin' && */}
                            <Link to='/createpublicworkshop'>
                              <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>PUBLIC WORKSHOPS</span>
                            </Link>
                          {/* } */}
                          {this.props.user.getUser().role === 'admin' &&
                            <Link to='/createorganization'>
                              <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>Organisations Webinars</span>
                            </Link>
                          }
                          {this.props.user.getUser().role === 'admin' &&
                            <Link to='/createorganizationworkshop'>
                              <span className="btn bordered empty grey-empty" style={{marginLeft: 10}}>Organisations Workshops</span>
                            </Link>
                          }
                        </div>
                      </div>

                    </div>
                    <div className="row align-items-center">

                      <div className="col-2">
                        <div className={classNames('accordion-content-block accordion-content-block-date', {'active-date': this.props.publicWebinarCreate.workshop.start_date,'dates-error': this.props.publicWebinarCreate.errors.start_date })}>

                            <SingleDatePicker
                              showClearDate={true}
                              displayFormat={'DD/MM/YYYY'}
                              placeholder="Start date"
                              date={this.props.publicWebinarCreate.workshop.start_date || null}
                              numberOfMonths={1}
                              onDateChange={(startDate) => {
                                this.props.publicWebinarCreate.handleChange({start_date: startDate});
                                this.setState({focusedInput: false})
                                }
                              }
                              focused={this.state.focusedInput}
                              onFocusChange={ () => {
                                  this.setState({focusedInput: !this.state.focusedInput})
                              }}
                            />
                          <span className="error">Empty</span>


                        </div>

                      </div>
                      <div className="col-1">
                        <div className={classNames('accordion-content-block time', {'active-date': this.props.publicWebinarCreate.workshop.start_time, 'dates-error': this.props.publicWebinarCreate.errors.start_time })}>
                          <TimePicker open={this.state.open}
                                      onOpen={this.setOpen}
                                      onClose={this.setOpen}
                                      value={this.props.publicWebinarCreate.workshop.start_time || null}
                                      showSecond={false}
                                      placeholder="Time"
                                      onChange={value => value && this.props.publicWebinarCreate.handleChange({start_time: value})}/>
                          <span className="error">Empty</span>
                        </div>
                      </div>
                      <div className="col-1">
                        <span className="border"/>
                      </div>
                      <div className="col-2">
                        <div className={classNames('accordion-content-block accordion-content-block-date',
                          {'active-date': this.props.publicWebinarCreate.workshop.end_date, 'dates-error': this.props.publicWebinarCreate.errors.end_date })}>
                          <SingleDatePicker
                            showClearDate={true}
                            placeholder="End date"
                            displayFormat={'DD/MM/YYYY'}
                            numberOfMonths={1}
                            date={this.props.publicWebinarCreate.workshop.end_date || null}
                            isOutsideRange={(day) => day.isBefore(this.props.publicWebinarCreate.workshop.start_date ? moment(this.props.publicWebinarCreate.workshop.start_date) : moment())}
                            onDateChange={(startDate) => {
                              this.props.publicWebinarCreate.handleChange({end_date: startDate});
                              this.setState({focusEnd: false})
                            }
                            }
                            focused={this.state.focusEnd}
                            onFocusChange={ () => {
                              this.setState({focusEnd: !this.state.focusEnd})
                            }}
                          />
                          <span className="error">Empty</span>
                        </div>
                      </div>
                      <div className="col-1">
                        <div className={classNames('accordion-content-block time',
                          {'active-date': this.props.publicWebinarCreate.workshop.end_time, 'dates-error': this.props.publicWebinarCreate.errors.end_time})}>
                          <TimePicker open={this.state.endOpen}
                                      onOpen={this.setOpenEnd}
                                      onClose={this.setOpenEnd}
                                      value={this.props.publicWebinarCreate.workshop.end_time || null}
                                      showSecond={false}
                                      placeholder="Time"
                                      onChange={value => value && this.props.publicWebinarCreate.handleChange({end_time: value})}/>
                          <span className="error">Empty</span>

                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-4">
                        <div className="accordion-content-block select-width online-customize-select"
                              style={{ marginTop: 27,
                                marginBottom: 0
                              }}>

                          <MultiSelectWrapper
                            elements={TARGET_AUDIENCES_MULTISELECT}
                            placeholder="Suitable for"
                            label="Suitable for"
                            name="target_audience"
                            value={this.props.publicWebinarCreate.getWorkShop().target_audience}
                            handleChange={this.handleChange}
                            errors={this.props.publicWebinarCreate.getErrors().target_audience}
                          />


                        </div>
                      </div>
                      <div className="col-2">
                           <Switcher name="cpd_hours"
                                     notChoosenText="No"
                                     value={this.props.publicWebinarCreate.getWorkShop().cpd_hours}
                                     placeholder="CPD hours"
                                     inputName="how_many_hours"
                                     inputValue={this.props.publicWebinarCreate.getWorkShop().how_many_hours}
                                     handleChange={this.handleChange}
                                     errors={this.props.publicWebinarCreate.getErrors().how_many_hours}
                           />
                      </div>
                      <div className="col-2">
                        <Switcher name="fee"
                                  value={this.props.publicWebinarCreate.getWorkShop().fee}
                                  placeholder="Workshop fee"
                                  inputName="cost"
                                  notChoosenText="No Fee"
                                  inputValue={this.props.publicWebinarCreate.getWorkShop().cost}
                                  handleChange={this.handleChange}
                                  errors={this.props.publicWebinarCreate.getErrors().cost}
                        />
                      </div>
                      <div className="col-2">
                        <Switcher name="limited_purchase"
                                  value={this.props.publicWebinarCreate.getWorkShop().limited_purchase}
                                  placeholder="Max Quantity"
                                  inputName="tickets_count"
                                  notChoosenText="No"
                                  inputValue={this.props.publicWebinarCreate.getWorkShop().tickets_count}
                                  handleChange={this.handleChange}
                                  errors={this.props.publicWebinarCreate.getErrors().tickets_count}
                        />
                      </div>
                    </div>

                    {this.props.publicWebinarCreate.workshop.add_modules && <AddDiscountCode/>}

                    <div className="col-2">
                      <Switcher name="visibility"
                        id="visibility"
                        name="visibility"
                        notChoosenText="No"
                        value={this.props.publicWebinarCreate.getWorkShop().visibility}
                        placeholder="Visibility"
                        hideInput
                        handleChange={this.handleChange}
                        leftTitle='Private'
                        rightTitle='Public'
                      />
                    </div>


                    <div className="row">
                      <div className="col-12">
                        <div className="accordion-content-block">
                         <BigInput
                           name="title"
                           type="text"
                           index="workshop"
                           value={this.props.publicWebinarCreate.getWorkShop().title}
                           handleChange={this.handleChange}
                           placeholder="Workshop title"
                           maxLength={50}
                           error={this.props.publicWebinarCreate.errors.title}/>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className={classNames({'col-12': true, 'has-error': this.props.publicWebinarCreate.getErrors().summary }) }>
                        <p className="label">Summary</p>
                        <Textarea
                          id="summary"
                          name="summary"
                          minRows={2}
                          className='animate-input'
                          value={this.props.publicWebinarCreate.getWorkShop().summary}
                          onChange={this.handleChangeSummary}
                          style={{lineHeight: 2}}
                          placeholder={'Enter text here. Max 150 Characters'}
                          maxLength="150"
                        />
                        <span className="error-text" style={{color: '#e91e63'}}>{this.props.publicWebinarCreate.errors.summary}</span>
                      </div>
                    </div>
                    {/* {this.props.user.getUser().role === 'admin' && */}
                      <div className="row">
                        <div className={classNames({'col-12': true, 'has-error': this.props.publicWebinarCreate.getErrors().zoom_link }) }>
                          <p className="label">Webinar Link</p>
                          <Textarea
                            id="zoom_link"
                            name="zoom_link"
                            minRows={2}
                            className='animate-input'
                            value={this.props.publicWebinarCreate.getWorkShop().zoom_link}
                            onChange={this.handleChangeWebinarLink}
                            style={{lineHeight: 2}}
                            placeholder={'Enter webinar link – make sure it starts with https://'}
                            maxLength="150"
                          />
                          <span className="error-text" style={{color: '#e91e63'}}>{this.props.publicWebinarCreate.errors.zoom_link}</span>
                        </div>
                      </div>
                    {/* } */}
                    <div className="row">
                      <div className={classNames({'col-12': true, 'has-error': this.props.publicWebinarCreate.getErrors().description }) }>
                        <p className="label">Workshop Description</p>

                        <QuillEditor
                          showToolbar={true}
                          onChange={this.handleChangeRte}
                          value={this.props.publicWebinarCreate.workshop.description}
                          placeholder={'Enter text here'}
                        />

                        <span className="text-editor-counter">{newCaption.length}/5000</span>
                        <span className="error-text" style={{color: '#e91e63'}}>{this.props.publicWebinarCreate.getErrors().description}</span>
                      </div>
                    </div>
                    <div className="row">
                      <div className='col-12'>
                        <div className="accordion-content-block">
                          <p className="label">Upload more info (optional)</p>
                          <ul className="file-list editing">
                            {this.props.publicWebinarCreate.getWorkShop().more_info ? FILE_PREVIEW : EMPTY_FILE}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Collapsible>
            </div>
            <div className="workshop-module gutter">
              <div className="accordion">
                {this.props.publicWebinarCreate.getModules().map( el => <AccordionModule id={el.key} key={el.key} />)}
              </div>
            </div>
          { ( (this.props.publicWebinarCreate.workshop.workshop_state === 'new_workshop' && this.props.publicWebinarCreate.workshop.add_modules) || (this.props.publicWebinarCreate.workshop.access_type==='owner' && this.props.publicWebinarCreate.workshop.add_modules) || this.props.user.getUser().role === 'admin') &&
            !this.props.publicWebinarCreate.workshop.bought &&
            <div className="btn-holder align-center">
              <div className="btn bordered white-bg add-modules" onClick={this.addEmptyModule}>ADD MODULE</div>
            </div>
          }
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/creat_public_webinar/WorkShopBasicInformation.jsx